import React from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import translationsJson from 'data/translations.json';
import './LanguageFilter.css';
import { LanguageGroup } from 'lib/Types';

const translations: Translations = translationsJson;

interface Props {
    onUpdate(language: LanguageGroup): void;
}

class LanguageFilter extends React.Component<Props, { currentValue: LanguageGroup }> {
    constructor(props: Props) {
        super(props);
        this.state = {
            currentValue: LanguageGroup.All
        }

        this.onChange = this.onChange.bind(this);
    }

    private onChange(event: SelectChangeEvent<unknown>, child: React.ReactNode) {
        const lang = String(event.target.value);
        let langGroup = LanguageGroup.All;
        if (lang === LanguageGroup.German)
            langGroup = LanguageGroup.German;
        else if (lang === LanguageGroup.Italian)
            langGroup = LanguageGroup.Italian;
        else if (lang === LanguageGroup.Ladin)
            langGroup = LanguageGroup.Ladin;

        this.setState({ currentValue: langGroup });
        if (this.props.onUpdate) {
            this.props.onUpdate(langGroup);
        }
    }

    render() {
        return (
            <FormControl className="dropdown">
                <InputLabel id="dropdown-label">{translations.languageGroup[window.lang]}</InputLabel>
                <Select labelId="dropdown-label" id="dropdown-select" onChange={this.onChange} value={this.state.currentValue} label={translations.languageGroup[window.lang]}>
                    <MenuItem value={LanguageGroup.All}>{translations.all[window.lang]}</MenuItem>
                    <MenuItem value={LanguageGroup.German}>{translations.de[window.lang]}</MenuItem>
                    <MenuItem value={LanguageGroup.Italian}>{translations.it[window.lang]}</MenuItem>
                    <MenuItem value={LanguageGroup.Ladin}>{translations.ld[window.lang]}</MenuItem>
                </Select>
            </FormControl>
        );
    }
}

export default LanguageFilter;